import React from 'react';
import clsx from 'clsx';
import styles from './Badge.module.scss';

export type BadgeTone = 'brand' | 'success' | 'warning' | 'neutral';

export interface IBadgeProps {
  tone?: BadgeTone;
  children: React.ReactNode;
  className?: string;
}

export default function Badge({
  tone = 'brand',
  children,
  className,
}: IBadgeProps) {
  return (
    <span className={clsx(styles.badge, styles[tone], className)}>
      {children}
    </span>
  );
}
